<template>
  <!-- 点検情報参照 -->
  <div id="AppInspectionView">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">点検情報参照</label>
        </div>
      </div>
    </div>
    <div style="margin-left: 50px; margin-Right: 50px;">
      <!-- 詳細表示 -->
      <div style="detailArea">
        <div>
          <div style="height:10px;"></div>
          <table class="is-full table">
            <table style="width: 100%;">
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">点検管理番号</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.inspectionCode }}</td>
              </tr>
              <tr>
                <!-- productFilter -->
                <th style="border-bottom: solid 1px; width: 200px;">品目名</th>
                <td
                  v-if="data.machineReplaceProductCode && data.machineReplaceProductCode!=data.productCode"
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{data.machineReplaceProductCode|productFilter(productMaster)}}({{data.machineReplaceSerialNumber }}) ⇒ {{data.productName}}({{data.serial }})</td>
                <td
                  v-else-if="data.machineReplaceSerialNumber"
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{data.productName}}({{ data.machineReplaceSerialNumber }} ⇒ {{data.serial}})</td>
                <td
                  v-else
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{data.productName}}({{ data.serial }})</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">疾患名</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{data.diseaseName}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">療法（呼吸のみ）</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.therapy}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">感染症</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.infection}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">処方使用時間（呼吸）</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ data.usageTime | usageTimeFilter }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">実使用時間</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{data.elapsedTime}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検種別</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{data.inspectionKind | inspectionTypeFillter}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">器械交換</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.machineReplace }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検指示内容</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ data.inspectionOrder | inspectionOrderFilter }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">営業所</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ data.officeCode | officeFilter(officeMaster)}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検担当者</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{data.staffName}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">越境依頼先</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ data.crossBorderOfficeCode | officeFilter(officeMaster)}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="4">点検状況</th>
                <th style="border-bottom: solid 1px; width:100px;">実施状況</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <span
                    :class="['tag',
                    {'is-success':data.status == 6},
                    {'is-danger':data.status == 1},
                    {'is-warning':data.status == 2},
                    {'is-warning':data.status == 3},
                    {'is-warning':data.status == 4},
                    {'is-dark':data.status == 5}
                    ]"
                  >{{ data.status | inspectionStatusFillter}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実施予定月</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.scheduledMonth }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実施日時</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.completionDate }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">次回予定月</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.nextScheduledMonth }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="3">患者情報</th>
                <th style="border-bottom: solid 1px;">患者名</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.patientName }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">患者住所</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  〒{{data.patientZipCode}} {{ data.patientAddress }}
                  <b-field class="file" style="float:right">
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="google-maps"
                      native-type="button"
                      v-on:click="doShowGoogleMap([
                      {
                          'address': data.patientAddress,
                          'name': data.patientName,
                          'patientZipCode': data.patientZipCode,
                      }
                      ])"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">患者連絡先</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.patientPhone }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="4">医療機関情報</th>
                <th style="border-bottom: solid 1px;">医療機関名</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.hospitalName }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">医療機関住所</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  〒{{data.hospitalZipCode}} {{ data.hospitalAddress }}
                  <b-field class="file" style="float:right">
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="google-maps"
                      native-type="button"
                      v-on:click="doShowGoogleMap([
                      {
                          'address': data.hospitalAddress,
                          'name': data.hospitalName,
                          'patientZipCode': data.hospitalZipCode,
                      }
                      ])"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">診療科</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{data.department}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">担当医</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{data.doctorName}}</td>
              </tr>
              <tr v-for="(item, index) in regularShomou" v-bind:key="index">
                <th
                  style="border-bottom: solid 1px;"
                  v-bind:rowspan="regularCount"
                  v-if="index==0"
                >定期消耗品</th>
                <td style="border-bottom: solid 1px;">{{item.itemCode}}</td>
                <td style="border-bottom: solid 1px;" colspan="3">
                  <span style="margin-left:10px;">{{item.itemCode|productFilter(productMaster)}}</span>
                  <div style="float:right">
                    <b-field>
                      <span>{{item.count}}</span>
                      <span style="margin-left:10px;">EA</span>
                    </b-field>
                  </div>
                </td>
              </tr>
              <tr v-for="(item, index) in nonRegularShomou" v-bind:key="index">
                <th
                  style="border-bottom: solid 1px;"
                  v-bind:rowspan="nonRegularCount"
                  v-if="index==0"
                >
                  非定期消耗品
                  <br />
                </th>
                <td style="border-bottom: solid 1px;">{{item.itemCode}}</td>
                <td style="border-bottom: solid 1px;" colspan="3">
                  <span style="margin-left:10px;">{{item.itemCode|productFilter(productMaster)}}</span>
                  <div style="float:right">
                    <b-field>
                      <span>{{item.count}}</span>
                      <span style="margin-left:10px;">EA</span>
                    </b-field>
                  </div>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="100">点検報告書送付先</th>
                <th style="border-bottom: solid 1px;width:150px;">患者</th>
                <td
                  v-if="disabledPatientForm"
                  style="border-bottom: solid 1px;width:150px;"
                >{{data.reportDestinationPatientForm|sendTypePatientFillter}}</td>
                <td
                  v-else
                  style="border-bottom: solid 1px; width:230px;"
                >
                  <b-field
                    :type="{'is-danger': errors.has('patientForm')}"
                    :message="errors.first('patientForm')"
                  >
                    <b-select
                      name="patientForm"
                      v-model="data.reportDestinationPatientForm"
                      data-vv-as="送付方法"
                      expanded
                    >
                      <option value="1">手持ち</option>
                      <option value="2">送付</option>
                      <option value="3">点検報告書送付不要</option>
                    </b-select>
                  </b-field>
                </td>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="6"
                >〒{{data.patientZipCode}} {{ data.patientAddress }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">医療機関</th>
                <td
                  v-if="disabledHospitalForm"
                  style="border-bottom: solid 1px;"
                >{{data.reportDestinationHospitalForm|sendTypeFillter}}</td>
                <td
                  v-else
                  style="border-bottom: solid 1px; width:230px;"
                >
                  <b-field
                    :type="{'is-danger': errors.has('hospitalForm')}"
                    :message="errors.first('hospitalForm')"
                  >
                    <b-select
                      name="hospitalForm"
                      v-model="data.reportDestinationHospitalForm"
                      data-vv-as="送付方法"
                      expanded
                    >
                      <option value="1">手持ち</option>
                      <option value="2">送付</option>
                      <option value="3">N/A</option>
                      <option value="4">PCP公開</option>
                      <option value="5">ナビエク郵送</option>
                    </b-select>
                  </b-field>
                </td>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="6"
                >〒{{data.hospitalZipCode}} {{ data.hospitalAddress }}</td>
              </tr>
            </table>
            <b-modal :active.sync="isShowGoogleMap" has-modal-card>
              <googleMap-form v-bind:marker="addressList"></googleMap-form>
            </b-modal>
          </table>
          <div class="column is-full">
            <b-field label="メモ" labelPosition="on-border">
              <b-input
                type="textarea"
                name="inspectionMemo"
                data-vv-as="メモ"
                v-validate="'max:512'"
                maxlength="512"
                rows="10"
                :readonly="roleId==2"
                v-model="data.freeMemo"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <!-- 余白 -->
    <div style="height: 50px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        v-if="roleId!=2"
        v-on:click="saveMemo"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >メモ登録</b-button>
      <b-button
        v-if="!disabledSaveTargetAddress"
        v-on:click="saveTargetAddress"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >送付先登録</b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import MapTemplate from "./AppMapView";
const constUser = require("../utils/user");
const constInspection = require("../utils/inspection");

var regularShomou = [];
var regularCount = 0;
var nonRegularShomou = [];
var nonRegularCount = 0;

var data = {};
var officeMaster = [];
var usageTimeMaster = [
  { code: "0", name: "24時間" },
  { code: "1", name: "日中" },
  { code: "2", name: "夜間・睡眠時" },
  { code: "3", name: "労作時" }
];

var infectionMaster = [
  { code: "0", name: "無し" },
  { code: "1", name: "MRSA" },
  { code: "2", name: "HCV" },
  { code: "3", name: "HBV" },
  { code: "4", name: "Wa" },
  { code: "5", name: "その他" }
];
const MapForm = {
  props: ["marker"],
  components: {
    maps: MapTemplate
  },
  template: `
      <maps :markers="marker" />
    `
};
export default {
  name: "AppInspectionView",
  computed: {
    disabledPatientForm: function () {
      let disabled = false;
      if (this.roleId == constUser.ROLE_ID_MAP.callcenter) {
        disabled = true;
      } else {
        switch (this.data.reportDestinationPatientFormStatus) {
          case constInspection.PRINT_STATUS_MAP.outputed.code:
          case constInspection.PRINT_STATUS_MAP.outputedPcp.code:
          case constInspection.PRINT_STATUS_MAP.outputedNaviexp.code:
          case constInspection.PRINT_STATUS_MAP.viewed.code:
            disabled = true;
            break;
        }
      }

      return disabled;
    },

    disabledHospitalForm: function () {
      let disabled = false;
      if (this.roleId == constUser.ROLE_ID_MAP.callcenter) {
        disabled = true;
      } else {
        switch (this.data.reportDestinationHospitalFormStatus) {
          case constInspection.PRINT_STATUS_MAP.outputed.code:
          case constInspection.PRINT_STATUS_MAP.outputedPcp.code:
          case constInspection.PRINT_STATUS_MAP.outputedNaviexp.code:
          case constInspection.PRINT_STATUS_MAP.viewed.code:
            disabled = true;
            break;
        }
      }

      return disabled;
    },

    disabledSaveTargetAddress: function () {
      let disabled = this.disabledPatientForm && this.disabledHospitalForm;

      return disabled;
    },
  },

  methods: {
    back: function(event) {
      if (this.searchConditions == undefined) {
        this.$router.push(this.prevRoute.path);
      } else {
        this.$router.push({
          name: "AppInspectionSearch",
          params: { searchConditions: this.searchConditions }
        });
      }
    },
    doShowGoogleMap: function(address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },
    getInspectionDetailPOST: function(client) {
      return client.apis.apiInspection.getInspectionDetailPOST({
        body: {
          code: this.inspectionCode == "-" ? null : this.inspectionCode,
          productCode: this.productCode,
          patientCode: this.patientCode,
          serial: this.serial
        }
      });
    },
    getInspectionDetailPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      this.regularShomou = this.data.disposables.filter(
        x => x.deliveryKindFlag == 1
      );
      this.regularCount = this.regularShomou.length;
      this.nonRegularShomou = this.data.disposables.filter(
        x => x.deliveryKindFlag != 1
      );
      this.nonRegularCount = this.nonRegularShomou.length;
    },
    getInspectionDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    saveMemo: function(event) {
      // メモ登録処理
      this.saveInspectionMemo();
    },
    saveInspectionMemo: function() {
      var excuteApi = this.setInspectionOtherMemoPOST;
      var successCallBack = this.setInspectionOtherMemoPOSTSuccess;
      var errorCallBack = this.setInspectionOtherMemoPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInspectionOtherMemoPOST: function(client) {
      var obj = {
        patientCode: this.patientCode,
        productCode: this.productCode,
        serial: this.serial,
        reservationId: this.data.appointmentCode,
        freeMemo: this.data.freeMemo,
        editType: "0"
      };
      return client.apis.apiInspection.setInspectionOtherMemoPOST({
        body: obj
      });
    },
    setInspectionOtherMemoPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
    },
    setInspectionOtherMemoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    saveTargetAddress: function() {
      //WebAPI Call
      this.apiCall(
        this.putInspectionReportsPUT,
        this.putInspectionReportsPUTsucces,
        this.putInspectionReportsPUTerror
      );
      return;
    },

    putInspectionReportsPUT: function (client) {
      const inspectionReports = [];

      let inspectionReport = {};
      inspectionReports.push(inspectionReport);
      inspectionReport.reservationId = Number(this.data.appointmentCode);
      inspectionReport.inspectionId = Number(this.data.inspectionCode);
      inspectionReport.printType = constInspection.PRINT_TYPE_MAP.patient.code;
      inspectionReport.sendType = Number(this.data.reportDestinationPatientForm);
      inspectionReport.destinationId = 0;
      
      inspectionReport = {};
      inspectionReports.push(inspectionReport);
      inspectionReport.reservationId = Number(this.data.appointmentCode);
      inspectionReport.inspectionId = Number(this.data.inspectionCode);
      inspectionReport.printType = constInspection.PRINT_TYPE_MAP.hospital.code;
      inspectionReport.sendType = Number(this.data.reportDestinationHospitalForm);
      inspectionReport.destinationId = 1;

      const apiRes = client.apis.apiInspection.putInspectionReportsPUT({
        body: {
          isNoOperationHistory: true,
          inspectionReports: inspectionReports,
        },
      });
      return apiRes;
    },
    putInspectionReportsPUTsucces: async function (result) {
      this.showSuccess(result);
      return;
    },
    putInspectionReportsPUTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },
  },
  data() {
    var productCode = this.$route.params["productCode"];
    var patientCode = this.$route.params["patientCode"];
    var serial = this.$route.params["serial"];
    var inspectionCode = this.$route.params["inspectionCode"];
    var searchConditions = this.$route.params["searchConditions"];
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
      data,
      officeMaster,
      productMaster: [],
      isShowGoogleMap: false,
      addressList: [],
      productCode,
      patientCode,
      serial,
      searchConditions,
      inspectionCode,
      roleId,
      regularShomou,
      regularCount,
      nonRegularShomou,
      nonRegularCount
    };
  },
  components: {
    "googleMap-form": MapForm
  },
  mounted: function() {
    // WebAPI Call
    var excuteApi = this.getInspectionDetailPOST;
    var successCallBack = this.getInspectionDetailPOSTSuccess;
    var errorCallBack = this.getInspectionDetailPOSTError;
    this.apiCall(excuteApi, successCallBack, errorCallBack);
    this.getProductList(this.productMaster);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  filters: {
    usageTimeFilter: function(value) {
      var usageTime = usageTimeMaster.find(v => v.code === value);
      if (usageTime) {
        return usageTime.name;
      }
      return "";
    },
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    productFilter: function(value, productMaster) {
      var deliveryElement = productMaster.find(v => v.productCode === value);
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppInspectionView.vue